import { combineReducers } from 'redux';
import authReducer from './auth';
import messageReducer from './message';
import uploadVectorReducer from './export';
import layersFeatureReducer from './layersFeature';
import layersReducer from './layersMap';
import layersBaseMapReducer from './layersBasemap';
import globalMapsReducer from './globalMaps';
import infoFeatureReducer from './infoFeature';
import infoReducer from './info';
import infoPanelReducer from './infoPanel';
import drawReducer from './draw';
import controlsReducer from './controls';

const rootReducer = combineReducers({
  auth: authReducer,
  authMessage: messageReducer,
  uploadVector: uploadVectorReducer,
  layers: layersReducer,
  layersFeature: layersFeatureReducer,
  layersBaseMap: layersBaseMapReducer,
  globalMaps: globalMapsReducer,
  infoFeature: infoFeatureReducer,
  info: infoReducer,
  infoPanel: infoPanelReducer,
  /*   draw: drawReducer,
  control: combineReducers, */
});

export default rootReducer;
